
function createProductCardHtml(product) {
    let colorOptionsHtml = '';

    // Check if there are multiple variants and assign their IDs to fixed color options
    if (product.variants && product.variants.length > 1) {
        const variantIds = product.variants.map(variant => variant.id);
        colorOptionsHtml = `
            <label class="radio-label">
                <input type="radio" name="color-${product.id}" value="${variantIds[0]}" class="radio-button" id="Peach" checked>
                <span class="radio-custom"></span>
                <span class="radio-label-text">Peach</span>
            </label>
            <label class="radio-label">
                <input type="radio" name="color-${product.id}" value="${variantIds[1]}" class="radio-button" id="Sienna">
                <span class="radio-custom"></span>
                <span class="radio-label-text">Sienna</span>
            </label>
            <label class="radio-label">
                <input type="radio" name="color-${product.id}" value="${variantIds[2]}" class="radio-button" id="Mocha">
                <span class="radio-custom"></span>
                <span class="radio-label-text">Mocha</span>
            </label>
        `;
    }

    return `
        <div class="product-card">
            <div class="product-img-column"><a href="${product.link}" ><img loading="lazy" src="${product.image}" class="img"/></a></div>
            <div class="product-info">
            <div class="product-title">${product.title}</div>
            <div class="product-price">
                <div class="price">
                    <span>${product.price_formatted}</span>
                </div>
            </div>
            <div class="product-description">
                ${product.description}
            </div>
            <div class="action-container">
                ${colorOptionsHtml && `<div class="color-options">${colorOptionsHtml}</div>`}
                <div class="product-card-actions">
                    <button class="atc-btn add-to-cart" data-product-id="${product.id}">Add to cart</button>
                </div>
            </div>
            </div>
        </div>
    `;
}



function handleQuizEvent (e) {
    const data = e.detail;
  const resultType = data.answers["Octane: Quiz results - Cycle series quiz"];
  
    const quizElement = document.querySelector('.octane-ai-quiz-rendered');
      quizElement.style.display = 'none';
   
  if (resultType === "Menstruation") {
    const menstruationResultSection = document.querySelector('.menstruation-results-section');
        menstruationResultSection.style.display = 'flex';
    }
  if (resultType === "Follicular") {
         const follicularResultSection = document.querySelector('.follicular-results-section');
        follicularResultSection.style.display = 'flex';
    }
  if (resultType === "Ovulation") {
    const ovulationResultSection = document.querySelector('.ovulation-results-section');
        ovulationResultSection.style.display = 'flex';
    }
  if (resultType === "Luteal") {
     const lutealResultSection = document.querySelector('.luteal-results-section');
        lutealResultSection.style.display = 'flex';
    }
  if (resultType === "Irregular/No periods") {
     const lutealResultSection = document.querySelector('.inconclusive-results-section');
        lutealResultSection.style.display = 'flex';
    }
    const productContainer = document.querySelector('.product-container');
  const productsDiv = productContainer.querySelector('.products');
  
    productContainer.classList.remove("hide");
    productsDiv.innerHTML = '';

    data.product_blocks.forEach(productBlock => {
        productBlock.forEach(product => {
          
            const productHtml = createProductCardHtml(product);
            productsDiv.innerHTML += productHtml;
          
        });
    });
  // Add event listeners to 'Add to Cart' buttons
    const addToCartButtons = document.querySelectorAll('.add-to-cart');
    addToCartButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const productId = button.getAttribute('data-product-id');
            const selectedVariantInput = document.querySelector(`input[name="color-${productId}"]:checked`);
            
             // Use selected variant ID if available, else use the first variant ID, or product ID as a last resort
            let variantId;
            if (selectedVariantInput) {
                variantId = selectedVariantInput.value;
            } else {
                const productData = data.product_blocks.flat().find(p => p.id.toString() === productId);
                variantId = productData.variants.length > 0 ? productData.variants[0].id : productId;
            }

            const payload = {
                id: variantId,
                quantity: 1
            };

            fetch(`/cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => console.log('Item added to cart:', data))
            .catch(error => console.error('Error adding item to cart:', error));
        });
    });
};


document.addEventListener('octane.quiz.completed', handleQuizEvent);
document.addEventListener('octane.quiz.accessed', handleQuizEvent);


